export const parvoShelter = {
	formSchema: {
		us: {
			type: 'object',
			required: [
				'firstName',
				'lastName',
				'emailAddress',
				'caseDate',
				'practiceName',
				'clinicZipcode',
			],
			properties: {
				firstName: {
					type: 'string',
					title: 'First Name',
				},
				lastName: {
					type: 'string',
					title: 'Last Name',
				},
				emailAddress: {
					type: 'string',
					title: 'Email Address',
					pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
				},
				caseDate: {
					type: 'string',
					title: 'Date of Diagnosis',
					format: 'date',
				},
				practiceName: {
					type: ['string'],
					title: 'Shelter Name',
				},
				clinicZipcode: {
					type: 'string',
					title: 'Shelter Zip Code',
					pattern: '(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)',
				},
			},
		},
		testing: {
			type: 'object',
			required: [
				'firstName',
				'lastName',
				'emailAddress',
				'caseDate',
				'practiceName',
				'clinicZipcode',
			],
			properties: {
				firstName: {
					type: 'string',
					title: 'First Name',
				},
				lastName: {
					type: 'string',
					title: 'Last Name',
				},
				emailAddress: {
					type: 'string',
					title: 'Email address',
					pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
				},
				caseDate: {
					type: 'string',
					title: 'Date of Diagnosis',
					format: 'date',
				},
				practiceName: {
					type: ['string'],
					title: 'Shelter Name',
				},
				clinicZipcode: {
					type: 'string',
					title: 'Shelter Zip Code',
					pattern: '(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)',
				},
			},
		},
	},
	uiSchema: {
		'ui:rootFieldId': 'parvoShelter',
		'ui:order': [
			'firstName',
			'lastName',
			'emailAddress',
			'caseDate',
			'practiceName',
			'clinicZipcode',
		],
		description:
			'By clicking “Submit” I agree to Elanco’s <a href="https://www.elancostatements.com/en/terms-of-use/elanco-com">Terms of Use</a>, and acknowledge that Elanco will collect and process my personal information in accordance with Elanco’s <a href="https://privacy.elanco.com/en-us">Privacy Notice</a>.',
	},
}
